import './ImageOverlay.css';
import Image from './Image';
import ArrowLeft from '../common/ArrowLeft';
import ArrowRight from '../common/ArrowRight';
import { useSwipe } from '../utils/useSwipe';

// ImageOverlay component to display larger images

function ImageOverlay({ overlayImageIndex, setOverlayImageIndex, content, setIsOverlayOpen }) {

    const img = content.images[overlayImageIndex];

    const {handleTouchStart, handleTouchEnd, handlePrev, handleNext} = useSwipe(content.images, setOverlayImageIndex);

    return (
        <div className="ImageOverlay" onClick={() => setIsOverlayOpen(false)}>
            {content.images.length > 1 && (
                <button
                    className="ImageNavButton"
                    onClick={(e) => {
                        e.stopPropagation();
                        handlePrev();
                    }}
                    style={{ left: "20px", border: "2px solid white" }}
                >
                    <ArrowLeft />
                </button>
            )}

            <div
                className="OverlayImageWrapper"
                onClick={(e) => e.stopPropagation()}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <Image
                    className="OverlayImage"
                    img={img}
                    alt="Großansicht"
                    isOverlay={true}
                />
            </div>

            {content.images.length > 1 && (
                <button
                    className="ImageNavButton"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleNext();
                    }}
                    style={{ right: "20px", border: "2px solid white" }}
                >
                    <ArrowRight />
                </button>
            )}
        </div>
    );
}

export default ImageOverlay;